import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { Button, ButtonGroup, useToast } from '@chakra-ui/react'
import { graphql } from '@/__generated__/gql'
import { Drawer } from '@/components/drawer'
import { OfferForm, FormValues } from './components/offer-form'

const createOfferDocument = graphql(`
  mutation CreateOffer($input: OfferInput!) {
    createOffer(input: $input) {
      message
      offer {
        id
      }
    }
  }
`)

export function NewOfferRoute() {
  const navigate = useNavigate()
  const toast = useToast()
  const onClose = useCallback(() => navigate('..'), [navigate])

  const [createOffer, { loading: isSubmitting }] = useMutation(
    createOfferDocument,
    {
      refetchQueries: ['Offers'],
      onCompleted(data) {
        toast({
          status: 'success',
          title: data.createOffer.message,
          isClosable: true,
        })
        onClose()
      },
      onError(error) {
        toast({
          status: 'error',
          title: error.message,
          isClosable: true,
        })
      },
    }
  )

  const onSubmit = useCallback(
    async (input: FormValues) => {
      await createOffer({ variables: { input } })
    },
    [createOffer]
  )

  return (
    <Drawer
      title="Ny benchmark"
      onClose={onClose}
      footer={
        <ButtonGroup>
          <Button onClick={onClose}>Avbryt</Button>
          <Button
            form="offer-form"
            type="submit"
            colorScheme="blue"
            isLoading={isSubmitting}
          >
            Opprett benchmark
          </Button>
        </ButtonGroup>
      }
    >
      <OfferForm onSubmit={onSubmit} />
    </Drawer>
  )
}
